// SHARED-008: Button component
import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'danger';
}

export function Button({ variant = 'default', className = '', ...props }: ButtonProps) {
  const variantClass = variant !== 'default' ? ` cyber-btn--${variant}` : '';
  return (
    <button className={`cyber-btn${variantClass} ${className}`} {...props} />
  );
}
